export default "__VITE_ASSET__DtQunfop__"